import React, { useEffect, useState } from "react";
import "./style.scss";
import httpService from "../../../../common/httpService";
import { useNavigate, useParams } from "react-router-dom";
import { backendUrlImages } from "../../../../constant/config";
import SimpleLabelValue from "../../../SimpleLabelValue";
import toast from "react-hot-toast";
import axios from "axios";
import Input from "../../../../CoreComponent/Input";
import Dialog from "../../../../CoreComponent/Dialog";
import Select from "../../../../CoreComponent/Select";
import { Button, Grid, Typography } from "@mui/material";

const GroupTripRegistration = ({ availableDates, setIsDialogOpen, setTotalPrice }) => {
  function convertStringToObjects(input) {
    return input?.split(",").map((date) => ({
      label: date,
      value: date,
    }));
  }

  const dates = convertStringToObjects(availableDates);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [selectedDate, setSelectedDate] = useState("2024-12-10");
  const [companionsCount, setCompanionsCount] = useState();
  const [totalPriceLocal, setTotalPriceLocal] = useState(null);
  const [idT, setIdT] = useState(null);
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const token = localStorage.getItem("token");
  const BaseUrl = process.env.REACT_APP_BASE_URL;

  const handlePayment = async () => {
    const type = "group";
    const participantId = idT;

    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${BaseUrl}/paypal/create-payment`,
        {
          amount: totalPriceLocal,
          return_url: `https://eventscons.com/success/${type}/${participantId}/0`,
          cancel_url: `https://eventscons.com/failed`,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      window.location.href = response.data.approval_url;
    } catch (error) {
      console.error("❌ Error while creating PayPal order:", error);
      alert("حدث خطأ، حاول مرة أخرى.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        `${BaseUrl}/group-trip-participants`,
        {
          trip_id: id,
          selected_date: selectedDate?.value,
          companions_count: companionsCount,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const price = response?.data?.participant?.total_price;
      setTotalPriceLocal(price);
      setTotalPrice(price);
      setIdT(response.data.participant.id);
      setSubmitted(true);
      toast.success("register successfully!");
    } catch (error) {
      if (error.response) {
        setError(error.response.data.message || "حدث خطأ في الطلب");
      } else {
        setError("حدث خطأ في الاتصال بالخادم");
      }
    }
  };

  const shouldShowPayButton = Number(totalPriceLocal) > 0;

  return (
    <div className="registration-container">
      <h2>Group Trip Registration</h2>

      {submitted ? (
        <div className="result">
          <h3>Total Price (USD): {totalPriceLocal} $</h3>

          {shouldShowPayButton ? (
            <button className="next-button" onClick={handlePayment} disabled={loading}>
              {loading ? "Processing..." : "Pay"}
            </button>
          ) : (
            <p className="free-message">This trip is free, so payment is not required.</p>
          )}
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="registration-form">
          <div className="form-group9">
            <Select
              options={dates}
              value={selectedDate}
              setValue={setSelectedDate}
              label="Selected Date"
              placeholder="Select..."
            />
            <Input
              label={"Companions Count"}
              type="number"
              inputValue={companionsCount}
              setInputValue={setCompanionsCount}
            />
          </div>

          <button type="submit" className="submit-button">
            Submit
          </button>
        </form>
      )}

      {error && <p className="error-message">{error}</p>}
    </div>
  );
};

const ViewOneTripUser = () => {
  const { id } = useParams();
  const [tripData, setTripData] = useState({});
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isMatched, setIsMatched] = useState(false);
  const [matchedParticipantId, setMatchedParticipantId] = useState(null);
  const [totalPrice, setTotalPrice] = useState(null);
  const navigate = useNavigate();
  const BaseUrl = process.env.REACT_APP_BASE_URL;

  const getAuthToken = () => localStorage.getItem("token");

  const getTripById = async () => {
    try {
      const response = await httpService({
        method: "GET",
        url: `${BaseUrl}/trip_option/${id}`,
        headers: { Authorization: `Bearer ${getAuthToken()}` },
        showLoader: true,
      });

      setTripData(response?.trip);
    } catch (error) {
      console.error("Error submitting discount", error);
    }
  };

  const getSpeakerDetailsAndMatch = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        alert("Token not found");
        return;
      }

      const currentUrlId = window.location.pathname.split("/").filter(Boolean).pop();

      const speakerResponse = await axios.get(`${BaseUrl}/speakers/info`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const speaker = speakerResponse?.data?.speaker || speakerResponse?.speaker;

      if (!speaker) {
        alert("Speaker data not found");
        return;
      }

      const participantsResponse = await axios.get(
        "https://eventscons.com/eventbackendnew/api/trip-participants/group/all",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const participants =
        participantsResponse?.data?.data ||
        participantsResponse?.data?.participants ||
        participantsResponse?.data ||
        [];

      const matchedItem = Array.isArray(participants)
        ? participants.find(
            (item) =>
              String(item?.user_id) === String(speaker?.user_id) &&
              String(item?.trip_id) === String(currentUrlId)
          )
        : null;

      if (matchedItem) {
        setIsMatched(true);
        setMatchedParticipantId(matchedItem?.id);
        setTotalPrice(matchedItem?.total_price || null);
      } else {
        setIsMatched(false);
        setMatchedParticipantId(null);
        setTotalPrice(null);
      }
    } catch (error) {
      console.error("Error fetching and matching data:", error);
      alert(error?.response?.data?.message || "Failed to fetch data");
    }
  };

  const handlePayNow = async () => {
    try {
      const token = localStorage.getItem("token");
      const type = "group";
      const participantId = id;

      const amountToPay = Number(totalPrice ?? tripData?.group_price_per_person ?? 0);

      if (amountToPay <= 0) {
        toast.info("No payment required");
        return;
      }

      const response = await axios.post(
        `${BaseUrl}/paypal/create-payment`,
        {
          amount: amountToPay,
          return_url: `https://eventscons.com/success/${type}/${participantId}/0`,
          cancel_url: `https://eventscons.com/failed`,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const approvalUrl = response?.data?.approval_url;
      if (approvalUrl) {
        window.location.href = approvalUrl;
      } else {
        alert("PayPal link not found");
      }
    } catch (error) {
      console.error("Pay Now error:", error);
      alert(error?.response?.data?.message || "Failed to create PayPal payment");
    }
  };

  const handleCancelRegistration = async () => {
    if (!matchedParticipantId) {
      toast.error("No registration found to cancel");
      return;
    }

    const confirmed = window.confirm("Are you sure you want to cancel your registration?");
    if (!confirmed) return;

    try {
      const token = localStorage.getItem("token");
      await axios.delete(
        `https://eventscons.com/eventbackendnew/api/trip-participants/${matchedParticipantId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("Registration cancelled");
      setTimeout(() => {
        window.location.reload();
      }, 800);
    } catch (error) {
      console.error("Cancel error:", error);
      toast.error(error?.response?.data?.message || "Failed to cancel registration");
    }
  };

  useEffect(() => {
    getTripById();
    getSpeakerDetailsAndMatch();
  }, []);

  const showPayNowButton = isMatched && Number(totalPrice ?? 0) > 0;

  const handleCloseDialogWithRefresh = () => {
    setIsDialogOpen(false);
    window.location.reload();
  };

  return (
    <Grid
      container
      spacing={2}
      justifyContent="center"
      alignItems={"center"}
      sx={{ padding: "20px" }}
    >
      {tripData?.image_1 && (
        <Grid item xs={12} md={5}>
          <div className="slider">
            <img
              src={`${backendUrlImages}${tripData.image_1}`}
              alt="Trip Image 1"
              style={{ width: "100%", height: "auto", borderRadius: "8px" }}
            />
          </div>
        </Grid>
      )}

      <Grid item xs={12} md={7}>
        {tripData?.name && (
          <Grid item xs={12}>
            <Typography variant="h4" textAlign={"center"} gutterBottom padding={2}>
              {tripData?.name}
            </Typography>
          </Grid>
        )}

        {tripData?.description && (
          <Grid item xs={12} padding={1}>
            <Typography variant="body1" color="textSecondary">
              {tripData?.description}
            </Typography>
          </Grid>
        )}

        {(tripData?.price_per_person > 0 ||
          tripData?.price_for_two > 0 ||
          tripData?.price_for_three_or_more > 0) && (
          <>
            <Grid item xs={12}>
              <Typography variant="h6" padding={1}>
                Price Information
              </Typography>
            </Grid>
            <Grid item xs={12} container spacing={2} padding={2}>
              {tripData?.price_per_person && (
                <Grid item xs={12} sm={6}>
                  <SimpleLabelValue
                    label="Price per person"
                    value={`$${tripData?.price_per_person}`}
                  />
                </Grid>
              )}
              {tripData?.price_for_two && (
                <Grid item xs={12} sm={6}>
                  <SimpleLabelValue
                    label="Price for two"
                    value={`$${tripData?.price_for_two}`}
                  />
                </Grid>
              )}
              {tripData?.price_for_three_or_more && (
                <Grid item xs={12} sm={6}>
                  <SimpleLabelValue
                    label="Price for three or more"
                    value={`$${tripData?.price_for_three_or_more}`}
                  />
                </Grid>
              )}
            </Grid>
          </>
        )}

        {tripData?.additional_options?.length > 0 && (
          <>
            <Grid item xs={12}>
              <Typography variant="h6" padding={1}>
                Additional Options
              </Typography>
            </Grid>
            <Grid item xs={12} container spacing={2} padding={2}>
              {tripData?.additional_options?.map((item) => (
                <Grid item xs={12} sm={6} key={item?.option_name}>
                  <SimpleLabelValue
                    label={item?.option_name}
                    value={`$${item?.price}`}
                  />
                </Grid>
              ))}
            </Grid>
          </>
        )}

        <Grid container spacing={2} justifyContent="center" alignItems={"center"} padding={2}>
          {tripData?.trip_type && (
            <Grid item xs={12} sm={6}>
              <SimpleLabelValue label="Trip Type" value={tripData?.trip_type} />
            </Grid>
          )}

          {tripData?.location && (
            <Grid item xs={12} sm={6}>
              <SimpleLabelValue label="Location" value={tripData?.location} />
            </Grid>
          )}

          {tripData?.inclusions && (
            <Grid item xs={12} sm={6}>
              <SimpleLabelValue label="Inclusions" value={tripData?.inclusions} />
            </Grid>
          )}

          {tripData?.group_price_per_person && (
            <Grid item xs={12} sm={6}>
              <SimpleLabelValue
                label="Group Price per person"
                value={`$${tripData?.group_price_per_person}`}
              />
            </Grid>
          )}

          {tripData?.group_price_per_speaker && (
            <Grid item xs={12} sm={6}>
              <SimpleLabelValue
                label="Group Price per speaker"
                value={`$${tripData?.group_price_per_speaker}`}
              />
            </Grid>
          )}

          {tripData?.duration > 0 && (
            <Grid item xs={12} sm={6}>
              <SimpleLabelValue
                label="Duration"
                value={`${tripData?.duration} Hours`}
              />
            </Grid>
          )}

          {tripData?.trip_details && (
            <Grid item xs={12}>
              <SimpleLabelValue
                label="Trip Details"
                value={tripData?.trip_details}
              />
            </Grid>
          )}

          {tripData?.trip_type === "group" && tripData?.available_dates && (
            <Grid item xs={12} sm={6}>
              <SimpleLabelValue
                label="Available Dates"
                value={tripData?.available_dates}
              />
            </Grid>
          )}

          {tripData?.trip_type === "group" &&
            (tripData?.group_accompanying_price ?? 0) > 0 && (
              <Grid item xs={12} sm={6} style={{ marginRight: "auto" }}>
                <SimpleLabelValue
                  label="Group Accompanying Price per Companion"
                  value={`$${tripData?.group_accompanying_price}`}
                />
              </Grid>
            )}
        </Grid>

        <Grid item xs={12}>
          {isMatched ? (
            showPayNowButton ? (
              <Grid container spacing={2} justifyContent={"center"}>
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="contained"
                    fullWidth
                    sx={{
                      color: "white",
                      backgroundColor: "#16a34a",
                      "&:hover": {
                        backgroundColor: "#15803d",
                      },
                    }}
                    onClick={handlePayNow}
                  >
                    Pay Now {totalPrice ? `($${totalPrice})` : ""}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="contained"
                    fullWidth
                    sx={{
                      color: "white",
                      backgroundColor: "#dc2626",
                      "&:hover": {
                        backgroundColor: "#b91c1c",
                      },
                    }}
                    onClick={handleCancelRegistration}
                  >
                    Cancel Registration
                  </Button>
                </Grid>
              </Grid>
            ) : (
              <Grid container spacing={2} justifyContent={"center"}>
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="contained"
                    fullWidth
                    sx={{
                      color: "white",
                      backgroundColor: "#dc2626",
                      "&:hover": {
                        backgroundColor: "#b91c1c",
                      },
                    }}
                    onClick={handleCancelRegistration}
                  >
                    Cancel Registration
                  </Button>
                </Grid>
              </Grid>
            )
          ) : (
            <Button
              variant="contained"
              color="primary"
              className="register-trip-btn"
              onClick={() => {
                if (tripData?.trip_type === "group") {
                  setIsDialogOpen(true);
                } else {
                  navigate(`/trip/user/${id}`);
                }
              }}
              sx={{
                color: "white",
                cursor: "pointer",
                backgroundColor: "#c62828",
                "&:hover": {
                  backgroundColor: "#dc143c",
                },
              }}
              fullWidth
            >
              Register now
            </Button>
          )}
        </Grid>
      </Grid>

      <Dialog
        viewHeader={true}
        header=""
        open={isDialogOpen}
        setOpen={handleCloseDialogWithRefresh}
      >
        <div className="dialog-message">
          <GroupTripRegistration
            id={id}
            availableDates={tripData?.available_dates}
            setIsDialogOpen={setIsDialogOpen}
            setTotalPrice={setTotalPrice}
          />
        </div>
      </Dialog>
    </Grid>
  );
};

export default ViewOneTripUser;